module.exports = __webpack_public_path__ + "img/Bitmap6.2e4bc6e6.png";